import { initWebBehaviorTracker } from './initWebBehaviorTracker';
import { emptyWebBehaviorTracker } from './types/webBehaviorTracker';
/**
 * If there is a need to update the tracker state after it has been initialized you can use this function.
 * It will replace the existing tracker attached to the window object.
 *
 * @category WebBehaviorTracker
 */
export var updateGlobalTracker = function (state) {
    var newTracker = initWebBehaviorTracker(state);
    attachTrackerToWindow(newTracker);
    return newTracker;
};
/**
 * Initializes an instance of web-behavior-tracker and attaches it to the window-object. As a consumer, you can call {@link getGlobalTracker} to retrieve it
 *
 * Usage:
 * ```typescript
 * // When your app is initialized
 * initGlobalTracker(initParams);
 *
 * // When your app has finished rendering
 * getGlobalTracker().page();
 * ```
 *
 * @param getInitParams
 * @category WebBehaviorTracker
 */
export var initGlobalTracker = function (getInitParams) {
    var newTracker = initWebBehaviorTracker(getInitParams);
    attachTrackerToWindow(newTracker);
    return newTracker;
};
/**
 * Retrieves the global tracker after it has been initialized. Details are documented in the [Readme](../pages/README.html)
 *
 * Usage:
 * ```typescript
 * // When your app is initialized
 * initGlobalTracker(initParams);
 *
 * // When your app has finished rendering
 * getGlobalTracker().page();
 * ```
 *
 * @category WebBehaviorTracker
 */
export var getGlobalTracker = function () {
    var _a;
    var tracker = (_a = window._sb1webbehaviortracker) === null || _a === void 0 ? void 0 : _a.call(window);
    if (!tracker) {
        console.warn('Tried to fetch global tracker instance of @sb1/web-behavior-tracker, but it does not exist. Has initGlobalTracker been called?');
        return emptyWebBehaviorTracker;
    }
    return tracker;
};
function attachTrackerToWindow(newTracker) {
    window._sb1webbehaviortracker = function () { return newTracker; };
}
//# sourceMappingURL=globalTracker.js.map